import React, { createContext, useContext, useEffect, useState } from 'react';
import { get, post } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = async () => {
    try {
      const u = await get('/auth/me');
      setUser(u);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshUser();
  }, []);

  const login = async (email, password) => {
    const r = await post('/auth/login', { email, password });
    setUser(r.user);
    return r.user;
  };

  const logout = async () => {
    try { await post('/auth/logout', {}); } catch (e) { /* ignore */ }
    setUser(null);
    window.location.href = '/login';
  };

  const isMaster = user?.role === 'MASTER';

  // Helpers de autorização
  const canAccessModule = (mod) => {
    if (!user) return false;
    if (isMaster) return true;
    return (user.allowed_modules || []).includes(mod);
  };

  const canAccessCompany = (companyId) => {
    if (!user) return false;
    if (isMaster) return true;
    return (user.allowed_company_ids || []).includes(companyId);
  };

  const visibleCompanies = (allCompanies) => {
    if (!user) return [];
    if (isMaster) return allCompanies;
    return allCompanies.filter((c) => (user.allowed_company_ids || []).includes(c.id));
  };

  return (
    <AuthContext.Provider value={{
      user, loading, isMaster, login, logout, refreshUser,
      canAccessModule, canAccessCompany, visibleCompanies,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
